var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7804 15.5559L19.6805 6.65561C19.8865 6.44976 20 6.17496 20 5.88196C20 5.58895 19.8865 5.31416 19.6805 5.10831L19.0252 4.45286C18.5982 4.02636 17.9042 4.02636 17.4779 4.45286L10.0041 11.9266L2.52209 4.44457C2.31608 4.23872 2.04145 4.12506 1.7486 4.12506C1.45543 4.12506 1.1808 4.23872 0.974625 4.44457L0.319508 5.10001C0.113495 5.30603 0 5.58066 0 5.87366C0 6.16667 0.113495 6.44146 0.319508 6.64732L9.22773 15.5559C9.43439 15.7622 9.71033 15.8755 10.0037 15.8749C10.2981 15.8755 10.5739 15.7622 10.7804 15.5559Z",
    fill: "#000033"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.e429f77728ac0bbca30e6dde0a26cd05.svg";
export { ForwardRef as ReactComponent };